import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
export function useDeleteThreadConfirmationFactory() {
    const { $t } = useIntl();
    return useCallback((itemTitle, subject = 'thread') => {
        const values = {
            itemTitle,
            span: (chunks) => React.createElement('span', { className: 'font-semibold line-clamp-3 break-words' }, chunks),
        };
        return {
            title: subject === 'task'
                ? $t({
                    defaultMessage: 'Delete session?',
                    description: 'Title of the confirmation modal when deleting a computer task',
                    id: 'e806dc402f',
                })
                : $t({
                    defaultMessage: 'Delete session?',
                    description: 'Title of the confirmation modal when deleting a thread',
                    id: 'e6e9a3b1f5',
                }),
            bodyText: subject === 'task'
                ? $t({
                    defaultMessage: 'This will permanently delete the session: <span>{itemTitle}</span>',
                    description: 'Body text of the confirmation modal when deleting a computer task',
                    id: '857172a8da',
                }, values)
                : $t({
                    defaultMessage: 'This will permanently delete the session: <span>{itemTitle}</span>',
                    description: 'Body text of the confirmation modal when deleting a thread',
                    id: 'a220aaa1cf',
                }, values),
            confirmButtonTitle: $t({
                defaultMessage: 'Delete',
                description: 'Confirm button label when deleting a thread or computer task',
                id: '1bff0ba1ea',
            }),
        };
    }, [$t]);
}
export function useDeleteThreadConfirmation(itemTitle, subject = 'thread') {
    const getConfirmation = useDeleteThreadConfirmationFactory();
    return useMemo(() => getConfirmation(itemTitle, subject), [getConfirmation, itemTitle, subject]);
}
//# sourceMappingURL=useDeleteThreadConfirmation.js.map